import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import api from "../../api";

const LastActiveUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchLastActiveUsers();
  }, []);

  const fetchLastActiveUsers = async () => {
    try {
      const res = await api.get(`/v1/last-active`, { withCredentials: true });
      setUsers(res.data);
    } catch (err) {
      console.error("Failed to fetch last active users:", err);
    }
  };

  const filteredUsers = users
    .filter((user) =>
      user.username.toLowerCase().includes(search.toLowerCase()),
    )
    .slice(0, 10);


  const appHost =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://pokemonradiance.com";

  return (
    <Card style={{ 
      borderRadius: '12px', 
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)', 
      border: 'none', 
      overflow: 'hidden' 
    }}>
      <CardHeader style={{ 
        background: '#1d222e', 
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)', 
        padding: '1.25rem 1.5rem' 
      }}>
        <h4 className="card-title mb-0" style={{ color: '#ffffff', fontWeight: 600 }}>Last Active Players</h4>
      </CardHeader>
      <CardBody style={{ 
        padding: '1.25rem', 
        backgroundColor: '#242836', 
        color: '#ffffff' 
      }}>
        <Input
          className="mb-3"
          placeholder="Search players..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ 
            borderRadius: '8px', 
            padding: '0.6rem 1rem', 
            border: '1px solid rgba(255, 255, 255, 0.1)', 
            backgroundColor: 'rgba(255, 255, 255, 0.05)', 
            color: '#ffffff' 
          }}
        />
        <ListGroup flush style={{ backgroundColor: 'transparent' }}>
          {filteredUsers.map((user) => (
            <ListGroupItem key={user.username} style={{ 
              borderRadius: '8px', 
              marginBottom: '0.5rem', 
              border: '1px solid rgba(255, 255, 255, 0.1)', 
              padding: '0.75rem 1rem', 
              backgroundColor: 'rgba(255, 255, 255, 0.05)', 
              transition: 'all 0.2s ease',
              color: '#ffffff'
            }}>
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3" style={{ position: 'relative' }}>
                  <img
                    style={{ 
                      width: '40px', 
                      height: '40px', 
                      borderRadius: '50%', 
                      objectFit: 'cover', 
                      border: '2px solid rgba(255, 255, 255, 0.2)' 
                    }}
                    alt={user.username}
                    src={`/avatars/${user.avatar}.png`}
                    onError={(e) => {
                      e.target.src = '/avatars/default.png';
                    }}
                  />
                  <div style={{ 
                    position: 'absolute', 
                    bottom: '0', 
                    right: '0', 
                    width: '12px', 
                    height: '12px', 
                    borderRadius: '50%', 
                    backgroundColor: '#10b981', 
                    border: '2px solid #242836' 
                  }}></div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <h5 className="mb-1" style={{ fontSize: '0.95rem' }}>
                    <Link
                      to={`/playerprofile?user=${user.username}`}
                      style={{ 
                        fontWeight: 600, 
                        color: '#ffffff', 
                        transition: 'color 0.2s ease' 
                      }}
                    >
                      {user.username}
                    </Link>
                  </h5>
                  <small style={{ color: 'rgba(255, 255, 255, 0.5)' }}>Last seen recently</small>
                </div>
                <div className="flex-shrink-0 ms-2">
                  <Button
                    type="button"
                    tag={Link}
                    to={`${appHost}/send-message?to=${user.username}`}
                    style={{ 
                      backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                      color: '#ffffff', 
                      border: '1px solid rgba(255, 255, 255, 0.2)', 
                      borderRadius: '6px', 
                      padding: '0.4rem 0.75rem', 
                      fontSize: '0.8rem', 
                      fontWeight: 500, 
                      transition: 'all 0.2s ease' 
                    }}
                  >
                    <i className="ri-mail-line" style={{ marginRight: '0.25rem' }}></i> Message
                  </Button>
                </div>
              </div>
            </ListGroupItem>
          ))}
          {filteredUsers.length === 0 && (
            <ListGroupItem className="text-center" style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.05)', 
              color: 'rgba(255, 255, 255, 0.5)', 
              fontStyle: 'italic', 
              border: '1px solid rgba(255, 255, 255, 0.1)' 
            }}>
              No active users found
            </ListGroupItem>
          )}
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default LastActiveUsers;
